import { render, staticRenderFns } from "./EmbryonAvailable.vue?vue&type=template&id=006d0d68&"
import script from "./EmbryonAvailable.vue?vue&type=script&lang=js&"
export * from "./EmbryonAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports